import React from 'react';

import { FormattedMessage, injectIntl } from 'react-intl';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import LockIcon from '@material-ui/icons/Lock';
import { useHistory } from 'react-router-dom';

import { useDispatch } from 'react-redux';
import { showLoading, hideLoading } from 'app/store/slices/settings';

import { URLS } from 'app/config/urls';
import { Formik, Form, Field } from 'formik';
import { Box, Grid, TextField, Container, Paper } from '@material-ui/core';
import * as Yup from 'yup';

import styles from './styles';
import notification from 'app/config/notification';
import authEndpoints from 'app/api/services/authEndpoints';
import BreadCrumb from 'app/components/BreadCrumb';
import { errorHandler } from 'app/utils/errorHandler';
const useStyles = makeStyles(styles);

const validationSchema = Yup.object().shape({
  password: Yup.string().required('Senha atual é obrigatória'),
  newPassword: Yup.string().required('Nova senha é obrigatória'),
  passwordConfirm: Yup.string().required('Confirmação de senha é obrigatória'),
});

function ChangePassword(props) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  const { intl } = props;

  const sendChangePassword = async values => {
    if (!values.password || !values.newPassword || !values.passwordConfirm) {
      notification(
        intl.formatMessage({
          id: 'MESSAGES.LOGIN.MISSING_MANDATORY_INFO_CHANGE_PASS',
        }),
        {
          toastId: 'MISSING_MANDATORY_INFO_CHANGE_PASS',
          type: 'error',
        }
      );
      return false;
    }
    if (values.newPassword !== values.passwordConfirm) {
      notification(
        intl.formatMessage({
          id: 'MESSAGES.LOGIN.PASSWORD_DOESNT_MATCH',
        }),
        {
          toastId: 'MISSING_MANDATORY_INFO_CHANGE_PASS',
          type: 'error',
        }
      );
      return false;
    }

    dispatch(showLoading());
    try {
      const response = await authEndpoints.changePassword(values.password, values.newPassword);
      if (response.status === 200) {
        notification(
          intl.formatMessage({
            id: 'MESSAGES.LOGIN.PASSWORD_CHANGED',
          }),
          { toastId: 'PASSWORD_CHANGED', type: 'success' }
        );
      }
      history.push(URLS.START);
    } catch (error) {
      errorHandler(error.response?.status, error.response?.data?.message);
    }
    dispatch(hideLoading());
  };

  const breadCrumb = [
    {
      title: intl.formatMessage({ id: 'LABELS.COMMONS.CHANGE_PASSWORD' }),
      path: '',
    },
  ];

  return (
    <Container>
      <BreadCrumb breadCrumb={breadCrumb} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.container} elevation={3}>
            <Formik
              enableReinitialize={true}
              initialValues={{ password: '', newPassword: '', passwordConfirm: '' }}
              validationSchema={validationSchema}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={values => {
                sendChangePassword(values);
              }}
            >
              {({ errors, values }) => {
                return (
                  <Form className={classes.containerForm}>
                    <Grid container spacing={3} className={classes.containerInt}>
                      <Grid item xs={12} className={classes.boxTextField}>
                        <LockIcon className={classes.icone} color="disabled" />
                        <Field
                          name="password"
                          label="Senha Atual"
                          type="password"
                          variant="filled"
                          fullWidth
                          error={!!errors.password}
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.boxTextField}>
                        <LockIcon className={classes.icone} color="disabled" />
                        <Field
                          name="newPassword"
                          label="Nova Senha"
                          type="password"
                          variant="filled"
                          fullWidth
                          error={!!errors.newPassword}
                          as={TextField}
                        />
                      </Grid>
                      <Grid item xs={12} className={classes.boxTextField}>
                        <LockIcon className={classes.icone} color="disabled" />
                        <Field
                          name="passwordConfirm"
                          label="Confirmar Senha"
                          type="password"
                          variant="filled"
                          fullWidth
                          error={!!errors.passwordConfirm}
                          as={TextField}
                        />
                      </Grid>
                      <div className={classes.actionsContainer}>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            color={'primary'}
                            className={classes.actionsBtns}
                            disableElevation
                            type="submit"
                          >
                            <Box className={classes.colorWhite}>
                              <FormattedMessage id="LABELS.COMMONS.SEND" />
                            </Box>
                          </Button>
                        </Grid>
                      </div>
                    </Grid>
                  </Form>
                );
              }}
            </Formik>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default injectIntl(ChangePassword);
